// src/components/marca/LogoHolaVeciLocal.js
//
// Marca de HolaVeci Local (antes "POS Compacto").
// Misma identidad de la landing de HolaVeci: título "¡Hola veci!" en
// Carter One + etiqueta "Local" en amarillo maduro sobre verde tienda.
//
// props:
//   size     -> font-size del título (por defecto 26)
//   compacto -> true oculta el subtítulo
//   light    -> variante clara para fondos oscuros

import React from 'react';
import { Box, Typography } from '@mui/material';

export default function LogoHolaVeciLocal({ size = 26, compacto = false, light = false }) {
  const colorTitulo    = light ? '#FBF7F0' : 'primary.main';
  const colorSubtitulo = light ? 'rgba(251, 247, 240, 0.75)' : 'text.secondary';

  return (
    <Box sx={{ lineHeight: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexWrap: 'nowrap' }}>
        <Typography
          component="div"
          sx={{
            fontFamily: `'Carter One', 'Fraunces', Georgia, serif`,
            fontWeight: 400,
            fontSize: size,
            color: colorTitulo,
            lineHeight: 1,
            whiteSpace: 'nowrap',
          }}
        >
          ¡Hola veci!
        </Typography>
        <Box
          component="span"
          sx={{
            fontFamily: `'DM Sans', sans-serif`,
            fontWeight: 700,
            fontSize: Math.max(10, Math.round(size * 0.42)),
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            bgcolor: 'secondary.main',
            color: 'primary.dark',
            borderRadius: 1,
            px: 0.75,
            py: 0.25,
            lineHeight: 1.2,
            whiteSpace: 'nowrap',
          }}
        >
          Local
        </Box>
      </Box>
      {!compacto && (
        <Typography
          variant="caption"
          sx={{ color: colorSubtitulo, fontSize: 11, mt: 0.5, display: 'block' }}
        >
          Caja, inventario y ventas de tu negocio
        </Typography>
      )}
    </Box>
  );
}
